const InputType = {
  YesNo: 1,
  Select: 2,
  TextFields: 3,
  DatePicker: 4,
  Checkbox: 5,
  TinField: 6,
  Dropdown: 7,
  CountryDropdown: 8,
  NumericField: 9,
  DateDropdown: 10,
  GiinField: 11,
};

export default InputType;
